export const messages = {
    recordCreated: ' has been created.',
    recordUpdated: ' has been updated.',
    recordSubmitted: ' has been submitted.',
    recordDeleteConfirm: 'Are you sure that you want to delete ',
    recordDeleteSuccess: ' has been deleted.'
};

export const exceptions = {
    gridRead: 'Grid Read Exception',
    editForm: 'Please create and assign a valid FormGroup instance to the cgp-grid.template'
};

export const exceptionTypes = {
    undefined: 'undefined',
};
